__turbopack_context__.v({
  "heading_body1": "Typography-module__L5lxgq__heading_body1",
  "heading_body2": "Typography-module__L5lxgq__heading_body2",
  "heading_body3": "Typography-module__L5lxgq__heading_body3",
  "heading_body4": "Typography-module__L5lxgq__heading_body4",
  "heading_h1": "Typography-module__L5lxgq__heading_h1",
  "heading_h2": "Typography-module__L5lxgq__heading_h2",
  "heading_h3": "Typography-module__L5lxgq__heading_h3",
  "heading_h4": "Typography-module__L5lxgq__heading_h4",
  "heading_subtitle": "Typography-module__L5lxgq__heading_subtitle",
});
